import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent<T> implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() displayFunction: (args: T) => string;
  @Input() filtro: string;
  @Input() lista: Array<T> = [];
  @Input() selectedItem: T;
  @Output() selectedItemChange = new EventEmitter<T>();
  @Output() itemChanged = new EventEmitter<T>();

  filtroAutocomplete = new UntypedFormControl();
  listaFiltrada: Observable<Array<T>>;

  constructor() {
  }

  ngOnInit() {
    if (this.selectItem) {
      this.filtroAutocomplete.setValue(this.selectItem);
    }

    // this.listaFiltrada = of(this.lista.filter(p => true));

    this.listaFiltrada = this.filtroAutocomplete.valueChanges
      .pipe(
        startWith(this.selectItem),
        map(value => this._filter(value))
      );
  }

  displayFn(item: T): string {
    if (item && this.displayFunction) {
      return this.displayFunction(item);
    }
    return '';
  }

  private _filter(value: any): Array<T> {
    if (typeof value === 'string') {
      this.selectItem(null);

      const filterValue = value.toLowerCase();

      return this.lista.filter(option =>
        (option[this.filtro] || '')
          .toString()
          .toLowerCase()
          .includes(filterValue)
      );
    }
    return this.lista;
  }


  selectItem(item: T): void {
    this.selectedItem = item;

    this.selectedItemChange.emit(item);
    this.itemChanged.emit(item);
  }
}
